<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CEkh9h/tc-custom/9781467462921.jpg?1730409918332" alt="This image is the cover for the book Reading Evangelicals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reading Evangelicals
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The story of five best-selling novels beloved by evangelicals, the book industry they built, and the collective imagination they shaped</i> </p><p>Who are evangelicals? And what is evangelicalism? Those attempting to answer these questions usually speak in terms of political and theological stances. But those stances emerge from an evangelical world with its own institutions—institutions that shape imagination as much as they shape ideology. </p><p>In this unique exploration of evangelical subculture, Daniel Silliman shows readers how Christian fiction, and the empire of Christian publishing and bookselling it helped build, is key to understanding the formation of evangelical identity. With a close look at five best-selling novels—<i>Love Comes Softly</i>, <i>This Present Darkness</i>, <i>Left Behind</i>, <i>The Shunning</i>, and <i>The Shack</i>—Silliman considers what it was in these books that held such appeal and what effect their widespread popularity had on the evangelical imagination. </p><p><i>Reading Evangelicals</i> ultimately makes the case that the worlds created in these novels reflected and shaped the world evangelicals saw themselves living in—one in which romantic love intertwines with divine love, humans play an active role in the cosmic contest between angels and demons, and the material world is infused with the literal workings of God and Satan. Silliman tells the story of how the Christian publishing industry marketed these ideas as much as they marketed books, and how, during the era of the Christian bookstore, this—every bit as much as politics or theology—became a locus of evangelical identity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel Silliman
      </h2>
      
      <p class="authorDescription body article"><B>Daniel Silliman</B>&#160;is senior news editor for&#160;<I>Christianity Today</I>. He earned a doctorate in American studies from Heidelberg University in Germany and has taught US history and humanities at Heidelberg, the University of Notre Dame, Valparaiso University, and Milligan University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c40f5e9